import { createContext, useContext, ReactNode } from 'react';
import { brand as defaultBrand } from './index';
import { BrandConfig } from './types';

const BrandContext = createContext<BrandConfig>(defaultBrand);

export function BrandProvider({ children, value }: { children: ReactNode; value?: BrandConfig }) {
  return <BrandContext.Provider value={value ?? defaultBrand}>{children}</BrandContext.Provider>;
}

export function useBrand(): BrandConfig {
  return useContext(BrandContext);
}
